import { render, staticRenderFns } from "./jump-animation.svg.vue?vue&type=template&id=01ae751b&scoped=true&"
import script from "./jump-animation.svg.vue?vue&type=script&lang=js&"
export * from "./jump-animation.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ae751b",
  null
  
)

export default component.exports